export default __webpack_public_path__ + "static/media/AllProductItems6.b6c2d0cb.png";